import ContactApi from './contacts/contacts-api';
import EventApi from './event-api';
import ContentApi from './content-api';

class SeamApi {
    constructor(url) {
        this.url = url;
        this.defaultError = 'System Error';
        this.defaultValidationHandler = errors => {
            console.error(errors)
        }

        this.defaultCancelHandler =  c => {
            console.log(c);
        }
    }

    handleError(error = this.defaultError) {
        throw new Error(error);
    }

    async handleResponse(caller, validationCallback = this.defaultValidationHandler) {

        try {
            return await caller();

        } catch (error) {
            console.log(error);
            
            if(error.message === 'canceled') {
                return false;
            }
            const { response } = error;

            if(response.status === 422) {
                validationCallback(response.data.errors);
                throw new Error('Validation Error');
            }
            this.handleError(response);
        }
    }

    formatUrl(path) {
        console.log(this.url, path)
        return `${this.url}${path}`;
    }

    async get(url, config, validation = this.defaultValidationHandler) {
        return this.handleResponse(() => {
            return axios.get(this.formatUrl(url), config);
        }, validation);
    }

    async post(url, config, validation = this.defaultValidationHandler, cancelHandler = this.defaultCancelHandler) {
        const source = axios.CancelToken.source();
        cancelHandler(source);
        return this.handleResponse(() => {
            return axios.post(this.formatUrl(url), config, { cancelToken : source.token});
        }, validation);
    }

    events() {
        return new EventApi(this);
    }

    contacts() {
        return new ContactApi(this);
    }

    content() {
        return new ContentApi(this);
    }
}


export default new SeamApi(process.env.MIX_API_URL);
